var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM20.6994 14.7544C18.7511 15.5704 14.871 17.2523 9.04249 19.7835C8.10994 20.1665 7.61035 20.5329 7.56039 20.8993C7.48665 21.5187 8.26204 21.7594 9.30805 22.084C9.44303 22.1259 9.58251 22.1691 9.72526 22.2148C10.7577 22.5479 12.1233 22.9309 12.8393 22.9475C13.4888 22.9642 14.2049 22.6978 15.0042 22.1482C20.4497 18.4679 23.2473 16.6028 23.4305 16.5695C23.5637 16.5362 23.7303 16.5029 23.8468 16.6028C23.9634 16.7027 23.9634 16.9026 23.9467 16.9525C23.8673 17.2836 20.6187 20.2994 19.1403 21.6719C18.7594 22.0255 18.4961 22.27 18.4347 22.3314C18.2785 22.4922 18.1194 22.6444 17.9665 22.7908C17.0107 23.7057 16.2933 24.3923 18.0017 25.5121C18.7783 26.0248 19.4048 26.4522 20.0216 26.8731C20.7671 27.3817 21.4987 27.8808 22.4646 28.5096C22.6922 28.659 22.9101 28.814 23.1226 28.9652C23.9522 29.5554 24.7007 30.0879 25.6287 30.0083C26.1616 29.9584 26.7111 29.4588 26.9942 27.96C27.6603 24.4296 28.9592 16.7527 29.259 13.5887C29.2923 13.3222 29.259 12.9725 29.2257 12.806C29.1924 12.6395 29.1424 12.423 28.9426 12.2565C28.6928 12.0566 28.3264 12.0233 28.1599 12.0233C27.4105 12.04 26.2448 12.4396 20.6994 14.7544Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default ForwardRef;